import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import messagesIcon from "../../../../../assets/images/speech-bubble-grey.svg";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";

import styles from "./StatementsOfWork.scss";

class StatementsOfWork extends React.Component {
  render() {
    const mappedMatches = this.props.matchesWithSOWs.map(match => {
      const project = _.get(match, "project");
      const pitch = _.get(match, "pitch");
      const sow = _.get(match, "pitch.sow");

      return {
        rowKey: sow.id,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: _.get(project, "status.display_name"),
            orderByText: _.get(project, "status.name")
          },
          {
            displayText: sow.accepted ? formatDateSmall(sow.updated_at) : "",
            orderByText: sow.accepted ? sow.updated_at : ""
          },
          {
            displayText: this.getMessagesIcon(pitch, project.id),
            orderByText: pitch.messages.length
          },
          {
            displayText: this.getButtonsDisplayText(project)
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "PROJECT"
        },
        {
          displayText: "STATUS"
        },
        {
          displayText: "SIGNED ON"
        },
        {
          displayText: "MESSAGES"
        },
        {
          displayText: "",
          sortDisable: true
        }
      ],
      rows: mappedMatches
    };

    const defaultSort = {
      headerIndex: 2,
      order: "asc"
    };

    return (
      <div className={styles.statements}>
        <h2 className={styles.pageTitle}>Statements of Work</h2>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name="AdminSOWTable"
          colsConfig={["50%", "25%", "20%", "5%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "employer.profile.company") || {};

    return (
      <div className={styles.rowHeader}>
        <div>
          <Link to={`/admin/company/${company.id}`}>{company.name}</Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link to={`/admin/project/${project.id}/detail`}>
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getMessagesIcon(pitch, projectId) {
    let messagesCount = _.isEmpty(pitch.messages) ? "0" : pitch.messages.length;

    if (messagesCount < 10) {
      messagesCount = "0" + messagesCount;
    }

    return (
      <div className={styles.actions}>
        <Link
          to={`/admin/project/${projectId}/pitch/${pitch.id}/messages`}
          className={styles.messages}
        >
          <img
            src={messagesIcon}
            alt="Messages"
            className={styles.messagesImage}
          />
          <span className={styles.messagesText}>{messagesCount}</span>
        </Link>
      </div>
    );
  }

  getButtonsDisplayText(project) {
    return (
      <div className={styles.actionsContainer}>
        <Link to={`/admin/project/${project.id}/sow`}>
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );
  }
}

export default StatementsOfWork;



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/statementsOfWork/components/StatementsOfWork.js